<template lang="html">
    <div>
        <UiInput
            label="Nume"
            image="user.svg"
            placeholder="Ex: Popescu"
            :value="secondStep.last_name"
            :error="errors.lastName"
            @input="updateLastName"
            @blur="validateLastName"
            @focus="errors.lastName = ''"
        />
        <UiInput
            label="Prenume"
            image="user.svg"
            placeholder="Ex: Andrei"
            :value="secondStep.first_name"
            :error="errors.firstName"
            @input="updateFirstName"
            @blur="validateFirstName"
            @focus="errors.firstName = ''"
        />
        <p class="error">{{apiError}}</p>
    </div>
</template>


<script>
import UiInput from '@/components/ui/Input'
import UiSelectDate from '@/components/ui/SelectDate.vue';

import { mapGetters } from 'vuex'

export default {
    components: {
        UiInput,
        UiSelectDate
    },
    data() {
        return {
            dob: null,
            errors: {
                firstName: '',
                lastName: '',
                dob: ''
            },
            apiError: null,
            isChanged: false
        }
    },
    computed: {
        ...mapGetters({
            secondStep: 'settings/secondStep',
            user: 'user/user',
        })
    },
    methods: {
        validateDob(value) {
            this.errors.dob = null;
            var date = new Date(value);
            if(date.getTime() >= new Date().getTime()) {
                this.errors.dob = 'Data nașterii este invalidă'
                return false;
            }
            return true;
        },
        validateFirstName() {
            this.apiError = null;
            if(this.secondStep.first_name.length > 0 && this.secondStep.first_name.length < 3 || this.secondStep.first_name.length > 30)
                this.errors.firstName = 'Numele trebuie să conțină minim 3 si maxim 30 de caractere';
            else this.errors.firstName = '';
        },
        validateLastName() {
            this.apiError = null;
            if(this.secondStep.last_name.length > 0 &&  this.secondStep.last_name.length < 3 ||  this.secondStep.last_name.length > 30)
                this.errors.lastName = 'Prenumele trebuie să conțină minim 3 si maxim 30 de caractere';
            else this.errors.lastName = '';
        },
        activeButton() {
            if((this.secondStep.first_name.length >= 3 &&  this.secondStep.first_name.length <= 30)
                && (this.secondStep.last_name.length >= 3 && this.secondStep.last_name.length <= 30)
                && this.validateDob(this.secondStep.dob))
                this.$emit('activeButton', true);
            else
                this.$emit('activeButton', false);
        },
        updateFirstName(event) {
            this.$store.state.settings.steps[1].payload['first_name'] = event;
            this.activeButton();
        },
        updateLastName(event) {
            this.$store.state.settings.steps[1].payload['last_name'] = event;
            this.activeButton();
        },
        updateDob(event) {
            this.$store.state.settings.steps[1].payload['dob'] = event;
            this.activeButton();
        }
    },
    watch: {
        dob(value) {
            this.apiError = null;
            if(value >= new Date())
                this.errors.dob = 'Data nașterii este incorectă';
            else this.errors.dob = '';
        },
        "$store._modules.root.state.notification"(notification) {
            if(notification.icon == 'error' && this.$store._modules.root.state.settings.currentStep == 1) {
                this.errors = [];
                this.apiError = notification;
            }
		},
        "$store._modules.root.state.settings.steps.1.payload.dob"(dob) {
            if(dob == null) {
                this.dob = '';
            } else {
                this.dob = dob;
            }
		},
        "$store._modules.root.state.user.user.dob"(dob) {
            if(dob == null) {
                this.dob = '';
            } else {
                this.dob = dob;
            }
		}
    },
    updated() {
        if(this.secondStep.dob == null) {
            this.dob = '';
        } else {
            this.dob = this.secondStep.dob;
        }
    },
    created() {
        if(this.secondStep.dob == null) {
            this.dob = '';
        } else {
            this.dob = this.secondStep.dob;
        }
    },
    mounted() {
        this.$emit('activeButton', true);
    }
}
</script>
